exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logo-container[data-v-6de91d8c]{background-size:cover;background-position:center bottom;background-color:grey;height:160px !important;overflow:hidden\n}\n.row-bottom-logo[data-v-6de91d8c]{margin-top:130px;margin-left:-10px\n}\n.col-margin-logo[data-v-6de91d8c]{margin-left:-15px;margin-right:-15px\n}\n.col-margin-logo-replace[data-v-6de91d8c]{margin-left:-12px;margin-right:-15px\n}\ninput[type=\"file\"][data-v-6de91d8c]{display:none\n}\n", ""]);

// exports
